exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button {\n\tfloat: right;\n}\n\n.card-save-wrapper {\n  float: right;\n}\n\n.tooltip {\n  position: relative;\n  display: inline-block;\n  opacity: 1;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 240px;\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%;\n  left: 50%;\n  margin-left: -120px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.tooltip .tooltiptext::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #555 transparent transparent transparent;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n  opacity: 1;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/MembriPay/src/app/components/payment/paymenttech-form/paymenttech-form.component.css
// module id = ../../../../../src/app/components/payment/paymenttech-form/paymenttech-form.component.css
// module chunks = main